<div class="card h-100">
   <div class="card-body">
      @let ownerContact = accountOwnerProfileContact();
      <h5 class="card-title fw-bold mb-0">{{ ownerContact?.info.displayName | uppercase }}</h5>
      @let ownerContactEmail = accountOwnerProfileContact()?.emailAddress;
      @if(ownerContactEmail) {
         @if (emailAsLink()) {
         <small class="ps-3 mb-1"><a class="text-decoration-underline" [href]="'mailto:' + ownerContactEmail">{{ ownerContactEmail }}</a></small>
         } @else {
         <small class="ps-3 mb-1">{{ ownerContactEmail }}</small>
         }
      }
      
      @if(partnerRepresentative()) {
      <div class="ps-3"><strong>Partner Representative: </strong> {{partnerRepresentative().sourceId}}</div>
      }
      <hr />
      <p class="card-text fw-bold" [class.mb-0]="plannedSubscriptionConversionOption() && nextPaymentDue()">{{ productSummary() }}</p>
      @if (plannedSubscriptionConversionOption() && nextPaymentDue()) {
      <div class="ps-3">
         <em><small class="text-muted ms-1">renews on <strong>{{ nextPaymentDue() | date:'MM/dd/yy' }}</strong> to&nbsp;</small></em>
         <strong>{{plannedSubscriptionConversionOption().productSummary}}</strong>
      </div>
      }
      @if (isMultiSeatProduct()) {
      <p class="card-text mb-0"><span class="fw-bold">Seats:</span> {{ seatsUsed() }} of {{ seatLimit() }} used</p>
      }
      <p class="card-text"><span class="fw-bold">Status:</span> <span class="fw-bold ms-1 {{ statusClass() }}">{{ statusDescription() }}</span></p>
   </div>
</div>
